let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1crI1")).then(() => parcelRequire('ARD7U'));